<app-page-loader *ngIf="isLoading"></app-page-loader>
<nz-drawer
[nzBodyStyle]="{ overflow: 'auto' }"
[nzMaskClosable]="false"
[nzWidth]="720"
[nzVisible]="showComponent"
nzTitle="{{taskDetail ? 'Update':'Add'}} Task"
[nzFooter]="footerTpl"
(nzOnClose)="close()"
>
<div class="" *nzDrawerContent>
<form nz-form  [formGroup]="taskForm" (ngSubmit)="submitForm()">

  <div nz-row [nzGutter]="24">
    <div nz-col nzSpan="24">
      <nz-form-item>
        
          <div nz-col nzSpan="5"> 
            <nz-form-label nzRequired nzFor="application">Apps</nz-form-label>
          </div>
          <div nz-col nzSpan="19"> 
            <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="Select an application!">
              <nz-select nzShowSearch nzAllowClear formControlName="application" id="application" [nzDisabled]="taskDetail != undefined" nzPlaceHolder="Select an application" (ngModelChange)="onSelectApp($event)">
                <nz-option *ngFor="let app of  applications" [nzLabel]="app.name" [nzValue]="app.id"></nz-option> 
              </nz-select>
            </nz-form-control> 
            </div>
       
      </nz-form-item>
    </div>


    <div nz-col nzSpan="24">
      <nz-form-item>
       
          <div nz-col nzSpan="5">
        <nz-form-label nzRequired>Task</nz-form-label>
        </div>
        <div nz-col nzSpan="19">
        <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="Please input task name!">
          <input type="text" nz-input placeholder="Title" (change)="titleAdded()" formControlName="name" id="name"/>
        </nz-form-control>
      </div>
       
      </nz-form-item>
    </div>


    <div nz-col nzSpan="24">
      <nz-form-item >
        <div nz-col nzSpan="5">
        <nz-form-label nzRequired>Task Type</nz-form-label>
      </div>
      <div nz-col nzSpan="19">
        <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="Select a task type!">
        <nz-select nzShowSearch nzAllowClear [nzMaxTagCount]="3" nzMode="multiple"
        [nzLoading]="isTaskTypesLoading"
        [nzDisabled]="isTaskTypesLoading || taskTypes.length == 0"
        formControlName="task_type" id="task_type"
         nzPlaceHolder="Task Type" >
          <nz-option *ngFor="let taskType of taskTypes" [nzLabel]="taskType.name" [nzValue]="taskType.id"></nz-option>
        </nz-select>
        </nz-form-control>
        </div>
      </nz-form-item>
    </div>


    <div nz-col nzSpan="24">
      <nz-form-item >
        <div nz-col nzSpan="5"> 
        <nz-form-label nzRequired>Priority</nz-form-label>
      </div>
      <div nz-col nzSpan="19"> 
        <nz-form-control [nzSm]="24" [nzXs]="24">
        <nz-select nzShowSearch nzAllowClear
        formControlName="priority" id="priority"
         nzPlaceHolder="Select task priority" >
          <nz-option *ngFor="let priority of priorities " 
          [nzLabel]="priority.name" [nzValue]="priority.id"
          ></nz-option> 
        </nz-select>
        </nz-form-control>
      </div>
      </nz-form-item>
    </div>

  
  <div nz-col nzSpan="24">
      <nz-form-item >
        <div nz-col nzSpan="5"> 
        <nz-form-label nzRequired>Due Date</nz-form-label>
      </div>
      <div nz-col nzSpan="19"> 
        <nz-form-control [nzSm]="24" [nzXs]="24">
          <nz-date-picker
          nzFormat="dd-MM-yyyy"
          formControlName="due_date"
        ></nz-date-picker>
        
        </nz-form-control>
      </div>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="24">
      <nz-form-item>
        <div nz-col nzSpan="5">  
        <nz-form-label>Description  </nz-form-label>
        <app-speech-to-text (SpeechToText)="getSpeechToText($event)"></app-speech-to-text>
        </div>
        <div nz-col nzSpan="19">
        <nz-form-control [nzSm]="24" [nzXs]="24">
          <!-- <textarea 
          formControlName="description" id="description"
          nz-input
          placeholder=""
          [nzAutosize]="{ minRows: 4, maxRows: 4 }"
        ></textarea> -->
        
        <quill-editor formControlName="description"  theme="snow"
        placeholder="Write description" class="content-editor" 
        [modules]="quillConfig"
         ></quill-editor>
        </nz-form-control>
        </div>
         
      </nz-form-item>
    </div>


    <div nz-col nzSpan="24">
      <nz-form-item >
        <div nz-col nzSpan="5">  
        <nz-form-label nzRequired>Status</nz-form-label>
        </div>
        <div nz-col nzSpan="19"> 
        <nz-form-control [nzSm]="24" [nzXs]="24" nzErrorTip="Select an Status!">
        <nz-select nzShowSearch nzAllowClear (ngModelChange)="statusChange($event)"
        [nzLoading]="isStatusesLoading"
        formControlName="task_status" id="status"
         nzPlaceHolder="Task status" >
          <nz-option *ngFor="let status of statuses" 
          [nzLabel]="status.name" [nzValue]="status.id"
          ></nz-option> 
        </nz-select>
        </nz-form-control>
      </div>
      </nz-form-item>
    </div>
    


    <div nz-col nzSpan="24">
      <nz-form-item >
        <div nz-col nzSpan="5"> 
        <nz-form-label>Assigned to</nz-form-label>
      </div>
      <div nz-col nzSpan="19"> 
        <nz-form-control [nzSm]="24" [nzXs]="24">
        <nz-select nzShowSearch nzAllowClear [nzMaxTagCount]="3" nzMode="multiple"
        formControlName="assigned_to" id="assigned_to"
         nzPlaceHolder="Assigned to" >
          <nz-option *ngFor="let user of getAssignableUsers()" [nzLabel]="getUserOptionLabel(user)" [nzValue]="user.id"></nz-option>
        </nz-select>
        </nz-form-control>
        </div>
      </nz-form-item>
    </div>

    <div nz-col nzSpan="24" *ngIf="taskDetail != undefined">
      <nz-form-item >
        <div nz-col nzSpan="5">  
        <nz-form-label >Progress</nz-form-label>
        </div>
        <div nz-col nzSpan="18"> 
          <div nz-col nzSpan="6"    >  
            <nz-input-number-group    [nzAddOnBefore]="addOnBeforeTemplate" [nzAddOnAfter]="addOnAfterTemplate" [nzSize]="'small'" [nzCompact]="true">
              <nz-input-number formControlName="progress" (ngModelChange)="updateTaskProgress()" [nzMax]="100" [nzMin]="0" [nzStep]="10" [nzSize]="'small'"  ></nz-input-number>
            </nz-input-number-group>
            <ng-template #addOnAfterTemplate>
              <span style="width:100%;border:none;background-color: transparent;cursor: pointer;" (click)="increase()"> + </span>
            </ng-template>
            <ng-template #addOnBeforeTemplate>
              <span style="width:100%;border:none;background-color: transparent;cursor: pointer;" (click)="decline()"> - </span>
            </ng-template>
            </div>
        </div>
      </nz-form-item>
    </div>
  
    <div nz-col nzSpan="24">
      <nz-form-item >
        <div nz-col nzSpan="5"> 
        <nz-form-label>Upcoming Release</nz-form-label>
      </div>
      <div nz-col nzSpan="19"> 
        <nz-form-control >
          <nz-switch (click)="updateUpcoming()" [nzControl]="true"  
          formControlName="is_upcoming_release" [nzDisabled]="UpcomingDisable"
          [nzCheckedChildren]="checkedTemplate"
          [nzUnCheckedChildren]="unCheckedTemplate" 
        ></nz-switch>
        <ng-template #checkedTemplate><span nz-icon nzType="check"></span></ng-template>
        <ng-template #unCheckedTemplate><span nz-icon nzType="close"></span></ng-template>
        </nz-form-control>
        </div>
      </nz-form-item>
    </div>
   


    <div nz-col nzSpan="24">
       
         
        <nz-form-item>
          <div nz-col nzSpan="5"> 
          <nz-form-label  >Link Feedback</nz-form-label>
         </div>
         <div nz-col nzSpan="19"> 
          <!-- <nz-form-control [nzSm]="24"  (nzOnSearch)="searchFeedback($event)"  [nzXs]="24" nzErrorTip="Please input feedback ID!">
            <input type="text" nz-input formControlName="link_feedback" id="link_feedback"
            nzPlaceHolder="Link a feedback">
          </nz-form-control> -->
          <!-- <nz-form-control [nzSm]="24" [nzXs]="24">
            <nz-select nzShowSearch nzServerSearch nzAllowClear  [nzShowArrow]="true" 
            (keyup)="inputkeyUp($event)"
            (keydown)="inputKeyDown()"
            formControlName="link_feedback" id="link_feedback"
             nzPlaceHolder="Please select feedback" >
              <nz-option *ngFor="let feedback of  feedbackListData" [nzLabel]="feedback.title" [nzValue]="feedback.id"></nz-option> 
            </nz-select>
            </nz-form-control> -->
          <p style="margin-top: 5px;text-transform: capitalize;">   {{taskDetail ? taskDetail.feedback_name : feedBackDetails ? feedBackDetails.title  : 'NA'}} </p>
          </div>
      </nz-form-item>
    </div>


    



  </div>

 
  

 


  <!-- <div nz-row [nzGutter]="24">
    <div nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label>Link Request</nz-form-label>
        <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select a feedback" [(ngModel)]="taskModel.link_feedback">
          <nz-option nzLabel="Request 1" nzValue="jack"></nz-option>
          <nz-option nzLabel="Request 2" nzValue="lucy"></nz-option>
          <nz-option nzLabel="Request 3" nzValue="tom"></nz-option>
        </nz-select>
      </nz-form-item>
    </div>
  </div> -->

  <nz-form-item nz-row class="register-area task-drawer-submit-action">
    <nz-form-control >
      <button nz-button nzType="primary" [disabled]="isLoading">{{taskDetail ? 'Update':'Create'}}</button>
    </nz-form-control>
  </nz-form-item>

</form>

<div nz-row [nzGutter]="24" >
 
  <div nz-col nzSpan="5"  > </div>
  <div nz-col nzSpan="19"  >  
    <div style="display:flex;justify-content: space-between;width: 102%;margin-left: -4px;"> 
        <nz-upload [nzAccept]="fileListUpload"
      [nzFileList]="fileList"
      [nzBeforeUpload]="beforeUpload"
      [nzRemove]="removeUpload"
      [nzDownload]="downloadUpload"
      >
      <button nz-button>
        <span nz-icon nzType="upload"></span>
        Attach Files
      </button>
      </nz-upload>
      <span style="text-align: right;"> <strong><sup>*</sup></strong>Max size 5mb.</span>
  </div>


  </div>

</div>
</div>
<ng-template #footerTpl>
  
  <div style="float: right">
    <!-- <button nz-button style="margin-left: 26px;" (click)="close()">Cancel</button> -->
  </div>
</ng-template>
</nz-drawer>
